module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "l-container"
  }, [_c('router-view', {
    attrs: {
      "user": _vm.user
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65df27fb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/User/User.vue
// module id = 1396
// module chunks = 0